import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const BookTariffModule = {
  namespaced: true,
  state: {
    processId: null
  },
  actions: {
    async bookTariff ({ commit, state, getters, rootGetters }, { tariffId }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation changeTariff ($bookTariff: BookTariffInput!) {
          changeTariff (bookTariff: $bookTariff){
            success,
            processId,
            contractUrl,
            notification{
              delay, text, title, id
            }
          }
        }`,
        variables: {
          bookTariff: {
            tariffId: tariffId
          }
        }
      }).then((response) => {
        commit('processId', response.data.changeTariff.processId)
        return response.data.changeTariff
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmTariff ({ commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient

      return apolloClient.mutate({
        mutation: gql`mutation changeTariff ($confirmTariffChange: ConfirmTariffChangeInput!) {
          confirmTariffChange (confirmTariffChange: $confirmTariffChange){
            basicFee
            dokManagerToken
            executionDate
            hardwareTransferFee
            newDurationDays
            newDurationMonths
            renewalFee
            singlePaymentFee
            success
          }
        }`,
        variables: {
          confirmTariffChange: {
            processId: state.processId
          }
        }
      }).then((response) => {
        if (response.data.confirmTariffChange.success) {
          commit('addMessage', {
            type: 'success',
            message: 'Tarif erfolgreich gebucht'
          }, { root: true })
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async initiateCancelTariff ({ commit, state }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation changeTariff{
          initiateCancelTariff {
            success,
            contractUrl,
            processId,
            notification {
              id,
              migratedId,
              text,
              title,
              delay,
              webText,
              webDetailsText
            }
          }
        }`
      }).then((response) => {
        commit('processId', response.data.initiateCancelTariff.processId)
        return response.data.initiateCancelTariff
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmCancelTariff ({ commit, state }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation cancelTariff ($confirmTariffCancel: ConfirmTariffCancelInput!) {
          confirmCancelTariff ( confirmTariffCancel: $confirmTariffCancel) {
            basicFee,
            dokManagerToken,
            executionDate,
            hardwareTransferFee,
            newDurationDays,
            newDurationMonths,
            notification {
              text
            }
            renewalFee,
            singlePaymentFee,
            success
          }
        }`,
        variables: {
          confirmTariffCancel: {
            processId: state.processId
          }
        }
      }).then((response) => {
        commit('processId', response.data.confirmCancelTariff.processId)
        return response.data.confirmCancelTariff
      }).catch((error) => {
        commit('processId', null)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmReverseTariff ({ commit, state }, { tariffId }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`mutation cancelPendingTariffChange ($CancelPendingTariffChangeInput: CancelPendingTariffChangeInput!) {
          cancelPendingTariffChange ( cancelPendingTariffChange: $CancelPendingTariffChangeInput) {
            success
          }
        }`,
        variables: {
          CancelPendingTariffChangeInput: {
            tariffId: tariffId
          }
        }
      }).then((response) => {
        return response
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    processId (state, id) {
      state.processId = id
    }
  },
  getters: {
    getProcessId: state => {
      return state.processId
    }
  }
}

export {
  BookTariffModule
}
